<template>
	<el-dialog
		title="更换管理员"
		:visible.sync="dialogVisible"
		width="480px"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		:show-close="false"
		destroy-on-close
	>
		<el-form ref="formRef" :model="form" :rules="rules" label-position="top">
			<el-form-item label="当前管理员绑定手机号">
				<el-input :value="maskedPhone" disabled />
			</el-form-item>
			<el-form-item label="短信验证码" prop="verifyCode">
				<div class="code-row">
					<el-input v-model.trim="form.verifyCode" placeholder="请输入验证码" maxlength="6" />
					<el-button :disabled="waitNum > 0" plain type="primary" @click="toSendMsg" class="send-btn">
						{{ waitNum > 0 ? waitNum + '秒后重发' : '获取验证码' }}
					</el-button>
				</div>
				<div class="field-tip">验证码将发送至当前绑定手机，用于验证身份</div>
			</el-form-item>
		</el-form>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="handleClose">取消</el-button>
				<el-button size="small" type="primary" @click="handleConfirm">下一步</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import { getMemberSms } from '@/api/user/login';
import TMessage from '@/utils/TMessage';
import { mapGetters } from 'vuex';

export default {
	name: 'DialogEditPhone',
	data() {
		return {
			dialogVisible: false,
			oldPhone: '',
			form: {
				verifyCode: '',
				verifyKey: ''
			},
			rules: {
				verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
			},
			waitNum: 0,
			wtimer: null
		};
	},
	computed: {
		maskedPhone() {
			if (!this.oldPhone) return '';
			return this.oldPhone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
		},
		...mapGetters('User', ['uinfo'])
	},
	watch: {
		dialogVisible(val) {
			if (!val) {
				this.stopWait();
			}
			if (val) {
				this.form.phone = this.uinfo.accountPhone;
			}
		}
	},
	methods: {
		// 外部调用：open(currentPhone)
		open(phone) {
			this.oldPhone = this.uinfo.accountPhone || '';
			this.form = { verifyCode: '', verifyKey: '' };
			this.dialogVisible = true;
		},

		// 发送验证码到当前手机
		toSendMsg() {
			if (!this.oldPhone) {
				TMessage.warning('当前未绑定手机号');
				return;
			}
			this.startWait();
			getMemberSms(this.oldPhone)
				.then(res => {
					const { code, data, msg } = res;
					if (code == 200) {
						this.form.verifyKey = data;
						TMessage.success('验证码已发送至当前绑定手机');
					} else {
						this.stopWait();
						TMessage.warning(msg || '短信发送失败');
					}
				})
				.catch(() => {
					this.stopWait();
					TMessage.error('发送失败，请重试');
				});
		},

		startWait() {
			this.waitNum = 60;
			if (this.wtimer) this.stopWait();
			this.wtimer = setInterval(() => {
				this.waitNum--;
				if (this.waitNum <= 0) this.stopWait();
			}, 1000);
		},

		stopWait() {
			clearInterval(this.wtimer);
			this.wtimer = null;
			this.waitNum = 0;
		},

		handleClose() {
			this.dialogVisible = false;
			this.stopWait();
			this.$refs.formRef && this.$refs.formRef.resetFields();
		},

		handleConfirm() {
			this.$refs.formRef.validate(valid => {
				if (valid) {
					// 验证通过，通知父组件进入下一步（绑定新手机）
					this.$emit('verified', {
						oldPhone: this.oldPhone,
						verifyCode: this.form.verifyCode,
						verifyKey: this.form.verifyKey
					});
					this.dialogVisible = false;
					this.stopWait();
				}
			});
		}
	},
	beforeDestroy() {
		this.stopWait();
	}
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
	border-bottom: 1px dashed #e2e8f0;
	margin-right: 0;
	background: #f8fafc;
}
/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}
/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
.code-row {
	display: flex;
	gap: 10px;
	align-items: center;

	.el-input {
		flex: 1;
	}
	.send-btn {
		white-space: nowrap;
		min-width: 120px;
	}
}
.field-tip {
	font-size: 12px;
	color: #94a3b8;
	margin-top: 6px;
}
</style>
